<template>
    <div class="Professores">
        <Header></Header>

        <div class="professores">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8 text-center">
                        <div class="my-4">
                            <span class="txt-p txt-size-25 txt-w-7 txt-white">
                                Professores
                            </span>
                            <p class="txt-p txt-size-16 txt-w-4 txt-white mb-5">
                                Confira nosso catálogo de cursos separado pelos ministrantes!
                            </p>
                        </div>
                        <div class="position-relative d-none">
                            <div class="input-busca">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="Busque um curso por nome ou tema" v-on:keyup.enter="pesquisar" v-model="termo">
                                    <span class="input-group-text bg-white c-pointer" @click="pesquisar" ><i class="fa-solid fa-magnifying-glass"></i></span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
                       
        <!-- CURSOS  -->
        <div class="container mt-3" v-for="(ministrante,index) in lstMinistrantes" :key="index">
            <div class="row">
                <div class="col-12">
                    <span class="txt-p txt-w-7 txt-size-20 txt-blue-3">
                        {{ministrante.ministrante.dsMinistrante}}
                    </span>
                </div>
            </div>
            <div class="row" id="itemList">
                <template v-if="ministrante.lstTreinamentos != null && ministrante.lstTreinamentos.length > 0">
                    <div class="col-12 col-md-4 mt-3" v-for="(item,index2) in ministrante.lstTreinamentos" :key="index2">
                        <div class="box-curso">
                            <div class="header-box">
                                <CarroselImagemCurso :lstImagens="item.lstImagens" v-if="item.lstImagens.length > 1"></CarroselImagemCurso>
                                <img class="img-curso" v-else :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" />
                                <div class="valor-curso bg-grey-6 px-3 py-2 " v-if="!item.flGratis">
                                    <p class="txt-p txt-w-7 txt-size-16 txt-blue-3 text-center mb-0">
                                        R$ {{moeda(item.vlTreinamento)}}
                                    </p>
                                </div>
                            </div>
                            <div class="conteudo pb-2">
                                <router-link :to="{name:'Curso', params:{id:item.idTreinamento}}" class="">
                                    <div class="detalhes px-3 py-2">
                                        <span class="txt-p txt-size-12 txt-w-7 txt-cores-3" v-if="item.flExclusivo">
                                            CURSO EXCLUSIVO
                                        </span>
                                        <span v-else>
                                            &nbsp;
                                        </span>

                                        <p class=" txt-size-16 txt-w-7 txt-grey-3 mb-2 reduz-texto-1">
                                            {{item.nmTreinamento}}
                                        </p>
                                        <p class="txt-p txt-size-12 txt-w-5 txt-grey-3 dsTreinamento reduz-texto-3">
                                            {{item.dsTreinamento}}
                                        </p>
                                    </div>

                                    <div class="d-flex flex-wrap w-100">
                                        <div class="col-12 col-lg-6 bg-grey-6">
                                            <div class="d-flex flex-wrap justify-content-evenly w-100 h-100">
                                                <div class="d-flex p-2 align-items-center w-50">
                                                    <i class="fa-solid fa-book-bookmark txt-size-20"></i>
                                                    <div class="d-flex flex-column ms-2">
                                                        <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0">
                                                            Tema
                                                        </p>
                                                        <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0 reduz-texto-1">
                                                            {{item.nmCategoria}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex p-2 align-items-center w-50">
                                                    <i class="fa-regular fa-clock txt-size-20"></i>
                                                    <div class="d-flex flex-column ms-2">
                                                        <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0">
                                                            Duração
                                                        </p>
                                                        <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0 reduz-texto-1">
                                                            {{item.duracaoTreinamento}} Horas
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6 ">
                                            <div class="d-flex flex-column py-2 px-3 justify-content-center">
                                                <p class="txt-p txt-w-5 txt-size-10 txt-blue-3 mb-1">
                                                    Avaliação média dos usuários:
                                                </p>
                                                <Estrelas :nota="item.nota" :qtdAvaliacoes="item.qtdAvaliacoes"></Estrelas>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>

                            <router-link class="btn-curso bg-cores-3 d-flex w-100 justify-content-center py-2 c-pointer" :to="{name:'Curso', params:{id:item.idTreinamento}}">
                                <span class="txt-p txt-w-7 txt-size-12 txt-white">
                                    Quero esse curso!
                                </span>
                            </router-link>

                        </div>
                    </div>
                    <div class="row mt-3 ">
                        <div class="col-12 d-flex justify-content-center" v-if="ministrante.qtdCursos > 3">
                            <b-pagination class="text-center" v-model="ministrante.currentPage"
                                          @input="paginacaoCursos(ministrante)"
                                          :total-rows="ministrante.qtdCursos"
                                          :per-page="3"
                                          ellipsis-class="d-none"
                                          aria-controls="itemList"></b-pagination>
                        </div>
                    </div>
                </template>
                <template v-else-if="ministrante.lstTreinamentos != null">
                    <div class="col-12">
                        <span class="txt-p txt-w-7 txt-size-14 txt-grey-3">
                            Nenhum curso encontrado.
                        </span>
                    </div>
                </template>
                
            </div>
           
            
        </div>
        <div class="row justify-content-center mt-5" v-if="qtdMinistrante != null">
            <div class="col-4">
                <button v-if="qtdMinistrante > (takeMinistrante*indexMinistrante)" class="btn btn-yellow txt-blue-1 w-100" @click="carregarMais">Carregar mais</button>
            </div>
            
        </div>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Estrelas from '@/components/Estrelas'
    import CarroselImagemCurso from '@/components/CarroselImagemCurso'

    import { urlApi, avisoErro, numeroParaMoeda } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Estante',
        components: { Header, Footer, Estrelas, CarroselImagemCurso  },
        data: function () {
            return {
                lstMinistrantes: [],

                termo: null,
                pesquisa: false,
               
               
                flPesquisa: false,
                takeMinistrante: 10,
                indexMinistrante: 0,
                qtdMinistrante: null,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        methods: {
            paginacaoCursos(ministrante) {
                ministrante.indexCursos = ministrante.currentPage == null || ministrante.currentPage == 0 ? 0 : ministrante.currentPage -1;
                this.getTreinamentos(ministrante.id);
            },

            load() {
                this.indexMinistrante = 0;
                this.lstMinistrantes = [];
                this.getMinistrantes();
            },

            carregarMais() {
                this.indexMinistrante = this.indexMinistrante + 1;
                this.getMinistrantes();
            },

            getMinistrantes(){
                 let $this = this;
                axios.get(`${urlApi}/Treinamento/GetMinistrantes`, { params: { take: $this.takeMinistrante, index: $this.takeMinistrante * $this.indexMinistrante, flCursoCapacitacao: true }} )
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.qtdMinistrante = res.data.data.qtdRecords;
                                for(let i = 0; i < res.data.data.rows.length; i++){
                                    $this.lstMinistrantes.push({id:i,indexCursos:0,qtdCursos:0,currentPage: 1, ministrante : res.data.data.rows[i],lstTreinamentos: null});

                                    $this.getTreinamentos($this.lstMinistrantes.length -1);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os ministrantes");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os ministrantes");
                    });
            },

            getTreinamentos(id){
                let $this = this;
                var ministrante = $this.lstMinistrantes[id];
                axios.get(`${urlApi}/Treinamento/Get`, { params: { take: 3, index: ministrante.indexCursos, nmProfessor: ministrante.ministrante.dsMinistrante, flCursoCapacitacao: true } })
                    .then(res => {
                        $this.flPesquisa = true;
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstMinistrantes[id].qtdCursos = res.data.data.qtdRecords;
                                var lst = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i].treinamento;

                                    item.flExclusivo = true;
                                    item.duracaoTreinamento = (item.duracaoTreinamento == null ? 0 : Math.ceil(item.duracaoTreinamento / 3600));

                                    item.nota = res.data.data.rows[i].avaliacao.nota;
                                    item.qtdAvaliacoes = res.data.data.rows[i].avaliacao.qtdAvaliacoes;
                                    item.lstImagens = res.data.data.rows[i].lstImagens;

                                    lst.push(item);
                                    //$this.lstCursos.push(item);
                                }

                                $this.lstMinistrantes[id].lstTreinamentos = lst;
                            }
                        } else {
                            avisoErro("Não foi possível carregar os cursos");
                        }
                    })
                    .catch(function () {
                        $this.flPesquisa = true;
                        avisoErro("Não foi possível carregar os cursos");
                    });
            },
            
            pesquisar() {
                if (this.termo != "") {
                    this.pesquisa = true;                    
                } else {
                    this.pesquisa = false;
                }
                this.load();
            },

            moeda(vlTreinamento) {
                return numeroParaMoeda(vlTreinamento);
            },
        },
        created: function () {
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .professores {
        background: linear-gradient(98.19deg, #0C1C25 1.55%, #163142 54.88%, #0C1C25 100%);
    }

    .input-busca {
        position: absolute;
        top: -25px;
        width: 100%;

        .form-control {
            background: #FFFFFF;
            border-left: 3px solid #143043;
            border-top: 3px solid #143043;
            border-bottom: 3px solid #143043;
            box-sizing: border-box;
            border-radius: 5px;
            border-right: none;

            height: 50px;
        }

        .input-group-text {
            color: #A6A6A6;
            background: #FFFFFF;
            box-sizing: border-box;
            border-radius: 5px;
            border-right: 3px solid #143043;
            border-top: 3px solid #143043;
            border-bottom: 3px solid #143043;
        }
    }

    .box-curso {
        a {
            color: unset;
        }

        .header-box {
            position: relative;
            height: 125px;

            .img-curso {
                /*position: absolute;
                top: 5px;*/
                border-radius: 7px;
                width: 100%;
                height: 125px;
                object-fit: cover;
            }

            .valor-curso {
                position: absolute;
                bottom: -5px;
                right: 0;
                border-radius: 5px 0 5px 0;
                z-index: 1;
            }
        }

        .conteudo {
            background: rgba(255, 255, 255, 0.25);
            border-left: 2px solid #A6A6A6;
            border-right: 2px solid #A6A6A6;
            box-sizing: border-box;

            .dsTreinamento {
                min-height: 54px;
            }
        }

        .btn-curso {
            border-radius: 0 0 7px 7px
        }

        .btn-curso:hover {
            background: #119b56 !important;
        }
    }


</style>

